import { useRef } from 'react';

import { useClickAway } from 'react-use';

import { Box } from '@mui/material';

// eslint-disable-next-line boundaries/element-types
import { SDrawer } from '@/widgets/sidebar/ui/TabletSidebar/styled';

import { RecordingSidebarContent } from './RecordingSidebarContent';

type Props = {
  isAuthenticated?: boolean;
  isOpen: boolean;
  onClose: () => void;
};

export const RecordingTabletSidebar = ({ isAuthenticated = true, isOpen, onClose }: Props) => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  const handleDrawerClose = () => {
    if (isOpen) {
      onClose();
    }
  };

  useClickAway(sidebarRef, handleDrawerClose);

  return (
    <Box aria-label="navigation sidebar" component="nav" display="flex" flexShrink={0}>
      <SDrawer open={isOpen} ref={sidebarRef} variant="temporary" hideBackdrop onClose={handleDrawerClose}>
        <RecordingSidebarContent
          isAuthenticated={isAuthenticated}
          isOpen={isOpen}
          handleCloseSidebar={onClose}
        />
      </SDrawer>
    </Box>
  );
};
